// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { multiplePromiseSettler } from '../../utils/index.tsx';
import { getNotificationPreferences, getTransitioningStatus } from '../endpoints/index.tsx';
import type {
	TransitioningStatusState,
	TransitioningStatusStoreContainerProps,
} from '../types.tsx';

const getData =
	(): Action<TransitioningStatusState, TransitioningStatusStoreContainerProps> =>
	({ setState, getState }, { cloudId, isAdmin }) => {
		const { loading } = getState();
		if (loading) {
			// We are already fetching and receive results, no need to start another request
			return;
		}

		setState({
			loading: true,
		});

		return Promise.allSettled([
			getNotificationPreferences(cloudId),
			getTransitioningStatus(cloudId, isAdmin),
		])
			.then(multiplePromiseSettler)
			.then(([notificationPreferencesResult, transitioningStatusResult]) => {
				if (
					notificationPreferencesResult.status === 'rejected' ||
					transitioningStatusResult.status === 'rejected'
				) {
					throw new Error('All promises should be fulfilled in then callback');
				}

				return {
					...notificationPreferencesResult.value,
					...transitioningStatusResult.value,
				};
			})
			.then(setState)
			.catch((error) => {
				// TODO: we might display toast
				setState({ error });
				throw error;
			})
			.finally(() => {
				setState({ loading: false });
			});
	};

const initialize = getData;

const deactivateOgApps =
	(): Action<TransitioningStatusState, TransitioningStatusStoreContainerProps> =>
	async ({ setState }) => {
		setState({
			areOgAppsDeactivated: true,
		});
	};

export const actions = { initialize, deactivateOgApps };
